import { render, staticRenderFns } from "./alarmsCard.vue?vue&type=template&id=634bdff6&"
import script from "./alarmsCard.vue?vue&type=script&lang=js&"
export * from "./alarmsCard.vue?vue&type=script&lang=js&"
import style0 from "./alarmsCard.vue?vue&type=style&index=0&id=634bdff6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports